/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsUnitHistoryTileData } from './lds-unit-history-tile.data';
import { ILdsUnitHistoryTileProps } from './lds-unit-history-tile.props.autogenerated';

export interface ILdsUnitHistoryTileViewProps extends ILdsUnitHistoryTileProps<ILdsUnitHistoryTileData> {}

/**
 *
 * LdsUnitHistoryTile component
 * @extends {React.PureComponent<ILdsUnitHistoryTileProps<ILdsUnitHistoryTileData>>}
 */
class LdsUnitHistoryTile extends React.PureComponent<ILdsUnitHistoryTileProps<ILdsUnitHistoryTileData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsUnitHistoryTile;
